import { fetchData } from "../../../api/api";
import { BETA_BASE_ROUTE } from "../../constants";
import { getErrorPageRoute } from "../../getExpectedBetaPath";
export const postAndRedirect = (params, successPath, locale) => fetchData({
    ...params,
    method: "POST",
})
    .then(() => {
    window.location.href = `${BETA_BASE_ROUTE}/${locale}${successPath}`;
})
    .catch((error) => {
    console.error(error);
    const errorPage = getErrorPageRoute(error?.message);
    window.location.href = `${BETA_BASE_ROUTE}/${locale}${errorPage}`;
});
//# sourceMappingURL=postAndRedirect.js.map